var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"alert-boxes"}},_vm._l((_vm.alerts),function(alert,index){return _c('div',{key:index},[_c('b-alert',{attrs:{"fade":"","dismissible":"","variant":alert.varient,"show":alert.show},on:{"dismissed":function($event){return _vm.updateAlert(index)}}},[_vm._v(" "+_vm._s(alert.message)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }